/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Deliverydelayprocess_Name2Inputs */

const en_resources_deliverydelayprocess_name2 = /** @type {(inputs: Resources_Deliverydelayprocess_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delay Process`)
};

const fr_resources_deliverydelayprocess_name2 = /** @type {(inputs: Resources_Deliverydelayprocess_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process Décalages`)
};

const es_resources_deliverydelayprocess_name2 = /** @type {(inputs: Resources_Deliverydelayprocess_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceso de retrasos`)
};

const de_resources_deliverydelayprocess_name2 = /** @type {(inputs: Resources_Deliverydelayprocess_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzögerungsprozess`)
};

const nl_resources_deliverydelayprocess_name2 = /** @type {(inputs: Resources_Deliverydelayprocess_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertragingsproces`)
};

/**
* | output |
* | --- |
* | "Delay Process" |
*
* @param {Resources_Deliverydelayprocess_Name2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_deliverydelayprocess_name2 = /** @type {((inputs?: Resources_Deliverydelayprocess_Name2Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Deliverydelayprocess_Name2Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_deliverydelayprocess_name2(inputs)
	if (locale === "fr") return fr_resources_deliverydelayprocess_name2(inputs)
	if (locale === "es") return es_resources_deliverydelayprocess_name2(inputs)
	if (locale === "de") return de_resources_deliverydelayprocess_name2(inputs)
	return nl_resources_deliverydelayprocess_name2(inputs)
});
export { resources_deliverydelayprocess_name2 as "resources.deliveryDelayProcess.name" }